module.exports = __webpack_public_path__ + "static/media/avi.cafab79c.svg";